/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import HomeTopPlaces from "../../../components/TopPlaces/HomeTopPlaces";
import {
  Container,
  Breadcrumb,
  BreadcrumbItem,
  InputGroup,
  InputGroupText,
  Input,
  Button,
} from "reactstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { IoIosSearch } from "react-icons/io";
import GridView from "./GridView/GridView";
import TableView from "./TableView";
import MapView from "./MapView";
import {
  changeView,
  hideLoader,
  showLoader,
} from "../../../utils/action/Action";
import { useSelector, useDispatch } from "react-redux";
import { placesByCategory } from "../../../services/category.service";
import { tzadikimCategory } from "../../../services/category.service";
import "./Cemetery.scss";
import swal from "sweetalert";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import {
  addUserFavorite,
  removeUserFavorite,
} from "../../../services/favourites.service";
import useDebounce from "../../../components/Debounce/Debounce";
import { MdGridOn } from "react-icons/md";
import { FiList } from "react-icons/fi";
import { IoMapOutline } from "react-icons/io5";
import { FaFilter } from "react-icons/fa";
import ContainerLayout from "../../../layout/ContainerLayout";
import marked_pop from "../../../assets/marked_pop.svg";

function Cemetery({ isUserLoggedIn }) {
  const location = useLocation();
  let { categoryName } = location?.state || "";
  let { categoryTitle } = location?.state || "";
  const { categoryIcon } = location?.state || "";
  const [viewName, setViewname] = useState("grid");
  const [categoryItem, setCategoryItem] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(200);
  const [totalCount, setTotalCount] = useState();
  const [checkForFavorite, setCheckForFavorite] = useState(null);
  const [debouceValue, setDebouceValue] = useState("");
  const [values, setValues] = useState({
    search: "",
  });

  console.log("Category Name /: ", categoryName);
  console.log("Category TItle /: ", categoryTitle);

  const [mapView, setMapView] = useState(false);

  var regex =
    /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;

  const current_value = useSelector(
    (state) => state.changeViewReducer.current_view,
  );
  const email = useSelector((state) => state.userDetailReducer.userData.email);
  const userName = useSelector(
    (state) => state.userDetailReducer.userData.userName,
  );
  const dispatch = useDispatch();
  const debounce = useDebounce();
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 0);
  }, []);

  useEffect(() => {
    current_value === "table"
      ? setViewname("table")
      : current_value === "grid"
        ? setViewname("grid")
        : setViewname("map");
  }, []);

  useEffect(() => {
    console.log("map view", mapView);
    if (values?.search?.length > 0) {
      if (values?.search?.length > 2) {
        categoryName === "Tzadikim" ? tzadikimPlace() : places();
        categoryName === undefined ? tzadikimPlace() : places();
      } else {
        toast.info("Please enter atleast 3 characters to get result.", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
      }
    } else {
      if (categoryName === "Tzadikim" || categoryName === undefined) {
        tzadikimPlace();
      } else if (mapView) {
        mapPlaces();
      } else {
        places();
      }
    }
  }, [debouceValue, currentPage, pageSize, mapView]);

  const places = async () => {
    if (categoryName === "Historical Places") {
      categoryName = "historical";
    } else if (categoryName === "Hotels") {
      categoryName = "motels";
    } else if (categoryName === "Synagogues") {
      categoryName = "synagogues";
    }
    try {
      dispatch(showLoader());
      const response = await placesByCategory(
        {
          Category: categoryName,
          Filter: values?.search?.trim(),
          email: email,
          checkForFavorite: true,
        },
        {
          pageNumber: currentPage,
          pageSize: 84,
        },
      );
      if (response && response?.status === 200) {
        setCategoryItem(response?.data?.data?.data);
        setCurrentPage(response?.data?.data?.pageNumber);
        setPageSize(pageSize);
        setTotalCount(response?.data?.data?.totalCount);
        dispatch(hideLoader());
      }
    } catch {
      dispatch(hideLoader());
    }
  };

  const mapPlaces = async () => {
    let page = 1;
    if (categoryName === "Historical Places") {
      categoryName = "historical";
    } else if (categoryName === "Hotels") {
      categoryName = "motels";
    } else if (categoryName === "Synagogues") {
      categoryName = "synagogues";
    }
    try {
      dispatch(showLoader());
      let finalResponse = [];
      const response = await placesByCategory(
        {
          Category: categoryName,
          Filter: values?.search?.trim(),
          email: email,
          checkForFavorite: true,
        },
        {
          pageNumber: page,
          pageSize: 100,
        },
      );

      let pageNum = page;

      if (response && response?.status === 200) {
        finalResponse = [...response?.data?.data?.data];
        setCategoryItem(finalResponse);
        console.log("type of finalRes", typeof finalResponse);
        const countFetch =
          (response?.data?.data?.totalCount - 100) / 100 > 0
            ? (response?.data?.data?.totalCount - 100) % 100 > 0
              ? (response?.data?.data?.totalCount - 100) / 100 +
                1 -
                ((response?.data?.data?.totalCount - 100) % 100) / 100
              : (response?.data?.data?.totalCount - 100) / 100
            : 0;
        console.log("count feeeeetch", countFetch);
        for (let i = 0; i < countFetch; i++) {
          pageNum++;
          console.log("fetching...", pageNum);
          const res = await placesByCategory(
            {
              Category: categoryName,
              Filter: values?.search?.trim(),
              email: email,
              checkForFavorite: true,
            },
            {
              pageNumber: pageNum,
              pageSize: 100,
            },
          );
          if (res && res?.status === 200) {
            // finalResponse = finalResponse.concat(res?.data?.data?.data)
            finalResponse = [...finalResponse, ...res?.data?.data?.data];
            console.log("concating ...", finalResponse.length);
          }
        }
      }

      // while(boocl) {
      // 	pageNum++
      // 	console.log("page num ", pageNum)
      // 	const res = await placesByCategory({
      // 		Category: categoryName,
      // 		Filter: values?.search?.trim(),
      // 		email: email,
      // 		checkForFavorite: true
      // 	}, {
      // 		pageNumber: pageNum,
      // 		pageSize: 100,
      // 	});
      // 	if(res && res?.status === 200) {
      // 		finalResponse = finalResponse.concat(res)
      // 		console.log("concating ...")
      // 	} else {
      // 		boocl = false
      // 	}
      // }

      console.log("final res length", finalResponse.length);
      console.log("fiiiiiiinal length", finalResponse.length);
      setCategoryItem(finalResponse);
      setCurrentPage(pageNum);
      setPageSize(pageSize);
      dispatch(hideLoader());

      if (true) {
        // const finalResponse = response?.data?.data?.data.concat(response2?.data?.data?.data)
        // console.log('data size', response?.data?.data?.data.length)
        // setCategoryItem(response?.data?.data?.data);
        // setCurrentPage(response?.data?.data?.pageNumber);
        // setPageSize(pageSize);
        // setTotalCount(response?.data?.data?.totalCount);
        // console.log("final res length", finalResponse?.data?.data?.data.length);
        // setCategoryItem(finalResponse?.data?.data?.data);
        // setCurrentPage(pageNum);
        // setPageSize(pageSize);
        // dispatch(hideLoader());
      }
    } catch {
      dispatch(hideLoader());
    }
  };

  const tzadikimPlace = async () => {
    try {
      dispatch(showLoader());
      const response = await tzadikimCategory(
        {
          Category: categoryName,
          Filter: values?.search?.trim(),
          email: email,
          checkForFavorite: true,
        },
        {
          pageNumber: currentPage,
          pageSize: 84,
        },
      );
      if (response && response?.status === 200) {
        setCategoryItem(response?.data?.data?.data);
        setCurrentPage(response?.data?.data?.pageNumber);
        setPageSize(pageSize);
        setTotalCount(response?.data?.data?.totalCount);
        dispatch(hideLoader());
      }
    } catch {
      dispatch(hideLoader());
    }
  };

  const handleClick = (view) => {
    dispatch(changeView(view));
    setViewname(view);
    setMapView(false);
  };

  const handleClickMapView = (view) => {
    dispatch(changeView(view));
    setViewname(view);
    setMapView(true);
  };

  const addToFavorite = async (id, fav) => {
    console.log("ewjqbfewkjqwe", isUserLoggedIn);
    if (isUserLoggedIn) {
      let categoryName = Object.keys(id)[0];
      const willFavorite = await swal({
        title: "Are you sure?",
        text: "You want to add this route in Favorites?",
        icon: marked_pop,
        buttons: true,
      });
      if (willFavorite) {
        try {
          const obj = {
            userName: userName,
          };
          const data = {
            mkmId: categoryName === "mkmID" ? id?.mkmID : null,
            tzId: categoryName === "tzadikimID" ? id?.tzadikimID : null,
          };
          console.log("data to add.....", data);
          const response = await addUserFavorite(data, obj);
          setCheckForFavorite(fav);
          if (response && response?.status === 200) {
            swal(
              "Added!",
              "Your route has been added in Favorites!",
              "success",
            );
            categoryName === "tzadikimID" ? tzadikimPlace() : places();
          }
        } catch (error) {
          toast.error(
            error?.response?.data?.message ||
              "Oops.. something went wrong, try again !!!",
            {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            },
          );
        }
      }
    } else {
      const notLoggedIn = await swal({
        title: "Please Continue to Log In",
        text: "You want to add this route in Favorites?",
        icon: marked_pop,
        buttons: ["Cancel", "Log In"],
      });
      if (notLoggedIn) {
        navigate("/sign-in");
      }
    }
  };

  const removeFromFavorite = async (id, fav) => {
    if (isUserLoggedIn) {
      let categoryName = Object.keys(id)[0];

      const willRemoveFavorite = await swal({
        title: "Are you sure?",
        text: "You want to remove this route from Favorites?",
        icon: marked_pop,
        buttons: true,
      });
      if (willRemoveFavorite) {
        try {
          const obj = {
            userName: userName,
          };
          const data = {
            mkmId: categoryName === "mkmID" ? id?.mkmID : null,
            tzId: categoryName === "tzadikimID" ? id?.tzadikimID : null,
          };
          const response = await removeUserFavorite(data, obj);
          setCheckForFavorite(fav);
          if (response && response?.status === 200) {
            swal(
              "Removed!",
              "Your route has been removed from Favorites!",
              "success",
            );
            categoryName === "tzadikimID" ? tzadikimPlace() : places();
          }
        } catch (error) {
          toast.error(
            error?.response?.data?.message ||
              "Oops.. something went wrong, try again !!!",
            {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            },
          );
        }
      }
    } else {
      const notLoggedIn = await swal({
        title: "Please Continue to Log In",
        text: "You want to remove this route from Favorites?",
        icon: marked_pop,
        buttons: ["Cancel", "Log In"],
      });
      if (notLoggedIn) {
        navigate("/sign-in");
      }
    }
  };

  const handleChange = (e) => {
    const newData = { ...values };
    newData[e?.target?.id] = e?.target?.value
      ?.replace(/^\s+/, "")
      .replace(regex, "");
    setValues(newData);
    debounce(() => setDebouceValue(newData));
  };

  const { title, subTitle } = location.state || {};

  return (
    <div
      className="main_section cemetery"
      style={{
        background: "#FFFCF8",
      }}
    >
      {/* <SearchBar /> */}
      {/* <div className='breadcrumb_section'>
				<Container >
					<Breadcrumb className="breadcrumb">
						<BreadcrumbItem>
							<Link to="/" className="breadcrumb_item1">Home</Link>
						</BreadcrumbItem>
						<BreadcrumbItem>
							<Link to="/" className="breadcrumb_item1">Category</Link>
						</BreadcrumbItem>
						<BreadcrumbItem>
							<Link to='/category-list' className="breadcrumb_item2" state={{ categoryName: categoryName, categoryTitle: categoryTitle, categoryIcon: categoryIcon }}>{categoryName}</Link>
						</BreadcrumbItem>
					</Breadcrumb>
				</Container>
			</div> */}

      <HomeTopPlaces />
      <div className="myroutes_section">
        <ContainerLayout classes={{ maxWidth: "1300px" }}>
          <div className="myroutes_box">
            <div className="myroutes_heading">
              <h4>
                {categoryName}/{categoryTitle}
              </h4>
            </div>
            {/* <div className="myroutes_box_header">
							<h4>{categoryName + '/' + categoryTitle}</h4>
							<div className="search_input">
								<InputGroup size="sm">
									<InputGroupText style={{ backgroundColor: "#FFFFFF" }}>
										<IoIosSearch size={25} />
									</InputGroupText>
									<Input
										type='search'
										id='search'
										name='search'
										value={values?.search}
										onChange={handleChange}
										maxLength="100"
										placeholder={`Search in ${categoryName}`}
										autoComplete='off'
									/>
								</InputGroup>
							</div>
						</div> */}

            <div className="header_bottom">
              <div className="left_side">
                <div className="search_input">
                  <IoIosSearch className="icon" />
                  <input
                    type="text"
                    id="search"
                    name="search"
                    placeholder={`Search in ${categoryName}`}
                    value={values?.search}
                    onChange={handleChange}
                    maxLength="100"
                    autoComplete="off"
                  />
                </div>
              </div>
              <div className="buttons_section">
                <div className="view_btns">
                  <Button
                    name="grid"
                    className={`${
                      viewName === "grid" ? "btn_grid" : "btn_table"
                    }`}
                    onClick={() => handleClick("grid")}
                  >
                    <MdGridOn />
                    Grid View
                  </Button>
                  <Button
                    name="table"
                    className={`${
                      viewName === "table" ? "btn_grid" : "btn_table"
                    }`}
                    onClick={() => handleClick("table")}
                  >
                    <FiList />
                    Table View
                  </Button>
                  <Button
                    name="map"
                    className={`${
                      viewName === "map" ? "btn_grid" : "btn_table"
                    }`}
                    onClick={() => handleClickMapView("map")}
                  >
                    <IoMapOutline />
                    Map View
                  </Button>
                </div>
              </div>
            </div>
            <div className="myroutes_block">
              {/* <div className="button_section">
								<div className="view_btn">
									<Button
										name="grid" className={viewName === 'grid' ? "active" : ""}
										onClick={() => handleClick('grid')}>
										Grid View
									</Button>
									<Button
										name="table" className={viewName === 'table' ? "active" : ""}
										onClick={() => handleClick('table')}>
										Table View
									</Button>
									<Button
										name="map" className={viewName === 'map' ? "active" : ""}
										onClick={() => handleClickMapView('map')}>
										Map View
									</Button>
								</div>
							</div> */}
              {viewName === "grid" ? (
                <GridView
                  name={categoryName}
                  categoryTitle={categoryTitle}
                  categoryIcon={categoryIcon}
                  categoryItem={categoryItem}
                  totalCount={totalCount}
                  pageSize={pageSize}
                  setCurrentPage={setCurrentPage}
                  currentPage={currentPage}
                  addToFavorite={addToFavorite}
                  removeFromFavorite={removeFromFavorite}
                />
              ) : viewName === "table" ? (
                <TableView
                  name={categoryName}
                  categoryTitle={categoryTitle}
                  categoryIcon={categoryIcon}
                  categoryItem={categoryItem}
                  totalCount={totalCount}
                  pageSize={pageSize}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  setPageSize={setPageSize}
                  addToFavorite={addToFavorite}
                  removeFromFavorite={removeFromFavorite}
                />
              ) : (
                <MapView
                  name={categoryName}
                  categoryTitle={categoryTitle}
                  categoryIcon={categoryIcon}
                  categoryItem={categoryItem}
                  addToFavorite={addToFavorite}
                  removeFromFavorite={removeFromFavorite}
                />
              )}
            </div>
          </div>
        </ContainerLayout>
      </div>
    </div>
  );
}

export default Cemetery;
